import { Component, input } from '@angular/core';

export type PillTone = 'ok' | 'warn' | 'crit' | 'info' | 'neutral' | 'done';

/**
 * The one source for a status / availability / severity pill. Callers pass a
 * pre-resolved `tone` (mapping a domain status to a tone stays in the feature,
 * or a shared util later) plus the `label` to show. Styled from design tokens.
 */
@Component({
  selector: 'app-status-pill',
  standalone: true,
  templateUrl: './status-pill.component.html',
  styleUrl: './status-pill.component.scss',
})
export class StatusPillComponent {
  label = input.required<string>();
  tone = input<PillTone>('neutral');
}
